import { ErrorData } from '@membranehq/sdk'
import { createMachine } from '@zag-js/core'

type MachineContext = {
  error?: ErrorData | null
  popupProps?: any | null
}
type MachineState = {
  value: 'closed' | 'open'
}

export const errorPopupMachine = createMachine<MachineContext, MachineState>(
  {
    id: 'errorPopup',
    initial: 'closed',
    context: {
      error: null,
      popupProps: null,
    },
    states: {
      closed: {
        on: {
          OPEN: {
            target: 'open',
            actions: ['setError'],
          },
        },
      },
      open: {
        on: {
          CLOSE: {
            target: 'closed',
            actions: ['clearError'],
          },
        },
      },
    },
  },
  {
    actions: {
      setError(context, event: any) {
        context.error = event?.error ?? null
        context.popupProps = event?.popupProps ?? null
      },
      clearError(context) {
        context.error = null
        context.popupProps = null
      },
    },
  },
)
errorPopupMachine.start()

export function showErrorInPopup(error: ErrorData | null, popupProps?: any) {
  if (error) {
    errorPopupMachine.send({ type: 'OPEN', error, popupProps })
  } else {
    errorPopupMachine.send({ type: 'CLOSE' })
  }
}
